import React from 'react';
import PageHeader from '../../components/PageHeader';
import { BRAND_NAME } from '../../utils/brand';

function MedicalAuthorization() {
  return (
    <>
      <PageHeader title="Medical Authorization" subtitle="Section 13.3 — User consent" />
      <div className="card prose">
        <p><strong>I acknowledge and consent to the following:</strong></p>
        <ul>
          <li>
            I authorize {BRAND_NAME} to share my medical and health data
            (including the answers I provide in the eligibility quiz, my
            BMI and metabolic indicators, and any lab results uploaded
            through the platform) with the clinic I select for treatment
            and evaluation.
          </li>
          <li>
            I understand the assigned clinic is independently licensed and
            responsible for the clinical decision to treat me. The platform
            facilitates information transfer only.
          </li>
          <li>
            I confirm that the answers I provide are truthful to the best
            of my knowledge. False information may put my safety at risk.
          </li>
          <li>
            I may withdraw consent at any time by contacting support, but
            withdrawal will not retroactively undo data already transferred
            to a clinic before withdrawal.
          </li>
        </ul>
      </div>
    </>
  );
}

export default MedicalAuthorization;
